import { useMemo } from 'react';
import { useDi, API_BASE_URL } from '../../app/providers/DiProvider';
import { PaymentsApi } from './payments.api';

/** Resolves the PaymentsApi client from the DI container (base URL comes from env). */
export function usePaymentsApi(): PaymentsApi {
  const di = useDi();
  return useMemo(() => new PaymentsApi(di.resolve(API_BASE_URL)), [di]);
}
